module.exports = __webpack_public_path__ + "static/software-preview-c18a547b40fe2b5a4ed541e52a88b047.jpg";